import React, { Component } from "react";
import PropTypes from "prop-types";
import { GridContainer, GridRow, GridColumn } from "arv-reactcomponents";

import { MyBag } from "npmlinks-constants";

class MybagSubheader extends Component {
  get showCartSize() {
    return this.props.bagTotalItemCount > 0 ? "" : "nwc-hide";
  }

  render() {
    const { bagTotalItemCount } = this.props;
    return (
      <div className="nw-mybagsubheader">
        <GridContainer>
          <GridRow>
            <GridColumn className="nw-mybagsubheader-wrapper">
              <span className="nw-mybagsubheader-text">
                {MyBag.MYBAGPAGE.MYBAG_TEXT}
              </span>
              <span className={`${this.showCartSize}`}>
                ({`${bagTotalItemCount}`})
              </span>
            </GridColumn>
          </GridRow>
        </GridContainer>
      </div>
    );
  }
}

MybagSubheader.propTypes = {
  bagTotalItemCount: PropTypes.number.isRequired,
};

const getFinalComponent = component => component;

const ProjectComponent = {
  getFinalComponent,
  wrapper: MybagSubheader,
  component: MybagSubheader,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/MybagSubheader/index.js